module.exports = __webpack_public_path__ + "static/no_result-cfbe77a9e9f7846b3dc50b22594d4fb3.jpg";